var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sourceId)?_c('div',{staticClass:"request-based-on"},[_c('span',[_vm._v(" Создано на основе обращения "),(_vm.canView)?_c('router-link',{staticClass:"request-based-on__number",attrs:{"to":_vm.sourceLink}},[_vm._v("№"+_vm._s(_vm.sourceId))]):_c('strong',[_vm._v("№"+_vm._s(_vm.sourceId))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }